import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import axios from "axios";
import { API } from "../App";

const FILE_ORIGIN = process.env.REACT_APP_BACKEND_URL || "";

// Global promo popup on the public landing page. Admin-configured, shown until
// the visitor closes it (then dismissed for that device, keyed by version so a
// new campaign shows again).
const SitePopup = () => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timer;
    axios
      .get(`${API}/site-popup`)
      .then((r) => {
        const d = r.data;
        if (!d || !d.active) return;
        if (localStorage.getItem(`hl_popup_${d.version}`)) return;
        setData(d);
        timer = setTimeout(() => setOpen(true), 3000); // appare dopo 3s dall'apertura del sito
      })
      .catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    if (data) localStorage.setItem(`hl_popup_${data.version}`, "1");
    setOpen(false);
  };

  if (!data) return null;
  const img = data.image_url
    ? (data.image_url.startsWith("http") ? data.image_url : `${FILE_ORIGIN}${data.image_url}?w=800`)
    : null;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[200] flex items-center justify-center p-4"
          data-testid="site-popup-overlay"
        >
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={close} />
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ type: "spring", stiffness: 260, damping: 24 }}
            className="relative w-full max-w-sm bg-white rounded-3xl overflow-hidden shadow-2xl"
            data-testid="site-popup"
          >
            <button
              onClick={close}
              aria-label="Chiudi"
              className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-md transition-colors"
              data-testid="site-popup-close"
            >
              <X className="w-5 h-5 text-zinc-700" />
            </button>

            {img && <img src={img} alt="" className="w-full h-48 sm:h-52 object-cover" loading="eager" />}

            <div className="p-6 text-center">
              {data.text && (
                <p className="text-zinc-700 whitespace-pre-line leading-relaxed text-[15px] font-medium mb-5">{data.text}</p>
              )}
              {data.button_text && data.button_link && (
                <a
                  href={data.button_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={close}
                  className="inline-flex items-center justify-center w-full rounded-full px-6 py-3.5 text-white font-bold text-base shadow-lg hover:-translate-y-0.5 transition-transform"
                  style={{ background: "linear-gradient(135deg,#ef4444,#dc2626)" }}
                  data-testid="site-popup-button"
                >
                  {data.button_text}
                </a>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SitePopup;
